import { Center, Heading, ScrollView, StatusBar, Text } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

import moneyDisplay from '../../../helpers/moneyDisplay';
import ActionButton from '../../../shared/ActionButton';
import FacesInput from '../../../shared/FacesInput';

function EditWallet({
  onDone,
  onWalletAdd,
  onWalletSub,
  walletContent,
  walletTotal,
}) {
  return (
    <>
      <StatusBar backgroundColor="#F4F8FB" barStyle="dark-content" />
      <Center bg="#F4F8FB" shadow="3" px="4" py="4">
        <Heading size="sm">Contenu du portefeuille</Heading>
        <Heading size="2xl">{moneyDisplay(walletTotal)}</Heading>
      </Center>
      <Center bg="#caf0f8" px="4" py="2">
        <Text>Sélectionnez les billets et pièces dont vous disposez.</Text>
      </Center>
      <ScrollView px="4">
        <FacesInput
          content={walletContent}
          onAdd={onWalletAdd}
          onSub={onWalletSub}
        />
      </ScrollView>
      <ActionButton onPress={onDone}>Terminer</ActionButton>
    </>
  );
}

EditWallet.propTypes = {
  onDone: PropTypes.func.isRequired,
  onWalletAdd: PropTypes.func.isRequired,
  onWalletSub: PropTypes.func.isRequired,
  walletContent: PropTypes.array.isRequired,
  walletTotal: PropTypes.number.isRequired,
};

export default EditWallet;
